import { isStyleOverridden, lookupCssValue, writeGap, writeGridPositionToCss, writeJustifyOrAlignContentToCss, writeJustifyOrAlignItemsToCss, writeLayoutStylesToCss, writeMargin, writePadding } from './gridLayoutStyleUtils';
import { writeBackgroundLayersToCss } from './backgroundLayerStylesUtils';
import combineBreakpointStyles from './combineBreakpointStyles';
import { buildContainerClassname } from './classNameUtils';
import { isFitContentWidth, isSizedWidth, isGridContainerLayout } from 'layout-data-lib/GridLayoutDataTree/typenameUtils';
function writeContainerStylesToCssHelper(styles, existingStylesByBreakpointName, layout) {
  Object.entries(styles).forEach(([breakpointName, style]) => {
    const stylesForBreakpoint = existingStylesByBreakpointName[breakpointName] || [];
    if (isStyleOverridden(style.justifyContent)) {
      stylesForBreakpoint.push(`justify-content: ${writeJustifyOrAlignContentToCss(style.justifyContent)};`);
    }
    if (isStyleOverridden(style.alignContent)) {
      stylesForBreakpoint.push(`align-content: ${writeJustifyOrAlignContentToCss(style.alignContent)};`);
    }
    if (isStyleOverridden(style.justifyItems)) {
      stylesForBreakpoint.push(`justify-items: ${writeJustifyOrAlignItemsToCss(style.justifyItems)};`);
    }
    if (isStyleOverridden(style.alignItems)) {
      stylesForBreakpoint.push(`align-items: ${writeJustifyOrAlignItemsToCss(style.alignItems)};`);
    }
    if (isStyleOverridden(style.isHidden)) {
      let displayValue;
      if (style.isHidden) {
        displayValue = 'none';
      } else {
        const currentLayout = layout[breakpointName] || layout.default;
        displayValue = isGridContainerLayout(currentLayout) ? 'grid' : 'flex';
      }
      stylesForBreakpoint.push(`display: ${displayValue};`);
    }
    if (isStyleOverridden(style.padding)) {
      stylesForBreakpoint.push(writePadding(style.padding));
    }
    if (isStyleOverridden(style.margin)) {
      stylesForBreakpoint.push(writeMargin(style.margin));
    }
    if (isStyleOverridden(style.gap)) {
      stylesForBreakpoint.push(writeGap(style.gap));
    }
    if (isStyleOverridden(style.gridPosition) || isStyleOverridden(style.gridSpanning)) {
      stylesForBreakpoint.push(writeGridPositionToCss(style.gridPosition, style.gridSpanning));
    }
    if (isStyleOverridden(style.flexGrow)) {
      stylesForBreakpoint.push(`flex-grow: ${style.flexGrow};`);
      stylesForBreakpoint.push(`flex-basis: 0;`);
    } else if (isStyleOverridden(style.width)) {
      if (isSizedWidth(style.width)) {
        stylesForBreakpoint.push(`width: ${style.width.size.value}${lookupCssValue(style.width.size.units)};`);
      } else if (isFitContentWidth(style.width)) {
        stylesForBreakpoint.push(`width: fit-content;`);
      }
    }
  });
}
export default function writeContainerStylesToCss(nodeId, layout, styles, breakpointMediaQueries) {
  const nodeSelector = `.${buildContainerClassname(nodeId)}`;
  const stylesByBreakpointName = breakpointMediaQueries.reduce((acc, [name]) => {
    acc[name] = [];
    return acc;
  }, {});
  const backgroundLayerStylesByBreakpointName = {};
  const backgroundLayersByBreakpointName = Object.keys(styles).reduce((acc, breakpointName) => {
    const stylesForBreakpoint = styles[breakpointName];
    if (stylesForBreakpoint !== null && stylesForBreakpoint !== void 0 && stylesForBreakpoint.backgroundLayers) {
      acc[breakpointName] = stylesForBreakpoint.backgroundLayers;
    }
    return acc;
  }, {});
  writeLayoutStylesToCss(layout, stylesByBreakpointName);
  writeContainerStylesToCssHelper(styles, stylesByBreakpointName, layout);
  writeBackgroundLayersToCss(nodeId, backgroundLayersByBreakpointName, backgroundLayerStylesByBreakpointName);
  return combineBreakpointStyles(breakpointMediaQueries, stylesByBreakpointName, nodeId, backgroundLayerStylesByBreakpointName, nodeSelector);
}